import { useEffect, useRef } from 'react';
import { trackScroll90 } from '@/lib/analytics';

export const useScrollTracking = () => {
  const hasTracked90 = useRef(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const fullHeight = document.documentElement.scrollHeight;
      
      const scrollPercentage = (scrollTop + windowHeight) / fullHeight * 100;
      
      // Track 90% scroll
      if (scrollPercentage >= 90 && !hasTracked90.current) {
        hasTracked90.current = true;
        trackScroll90();
      }
    };

    // Throttle scroll events for performance
    let ticking = false;
    const throttledHandleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', throttledHandleScroll, { passive: true });
    
    return () => {
      window.removeEventListener('scroll', throttledHandleScroll);
    };
  }, []);
};